import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Services from '../../api/service';
import ServiceSidebar from './sidebar'
import Navbar2 from '../../components/Navbar2/Navbar2'
import Logo from '../../images/logo2.png'
import Footer from '../../components/footer/Footer';

const ServiceSinglePage = () => {
    const { id } = useParams()
    const serviceDetails = Services.find(item => item.Id === id)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    if (!serviceDetails) {
        return (
            <Fragment>
                <Navbar2 hclass={'wpo-header-style-1'} Logo={Logo} />
                <PageTitle pageTitle={'Hizmet Bulunamadı'} pagesub={'Hata'} />
                <div className="wpo-service-single-area section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <h3>Aradığınız hizmet bulunamadı.</h3>
                                <p>Lütfen geçerli bir hizmet seçiniz.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
                <Scrollbar />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-1'} Logo={Logo} />
            <PageTitle pageTitle={serviceDetails.sTitle} pagesub={serviceDetails.pageTitle || 'Hizmet Detayı'} />

            <div className="wpo-service-single-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12">
                            <div className="wpo-service-single-wrap">

                                {/* Ana Görsel ve Başlık */}
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-main-img">
                                        <img src={serviceDetails.sImgS} alt={serviceDetails.sTitle} />
                                    </div>
                                    <div className="wpo-service-single-title">
                                        <h3>{serviceDetails.pageTitle || serviceDetails.sTitle}</h3>
                                    </div>
                                    <p>{serviceDetails.description}</p>
                                    {serviceDetails.des2 && <p>{serviceDetails.des2}</p>}
                                    {serviceDetails.des3 && <p>{serviceDetails.des3}</p>}

                                    {/* İkili Görseller */}
                                    {(serviceDetails.ssImg1 || serviceDetails.ssImg2) && (
                                        <div className="row mt-4">
                                            {serviceDetails.ssImg1 && (
                                                <div className="col-md-6 col-sm-6 col-12">
                                                    <div className="wpo-p-details-img">
                                                        <img src={serviceDetails.ssImg1} alt={`${serviceDetails.sTitle} - 1`} />
                                                    </div>
                                                </div>
                                            )}
                                            {serviceDetails.ssImg2 && (
                                                <div className="col-md-6 col-sm-6 col-12">
                                                    <div className="wpo-p-details-img">
                                                        <img src={serviceDetails.ssImg2} alt={`${serviceDetails.sTitle} - 2`} />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* Sidebar */}
                        <ServiceSidebar currentService={serviceDetails} />
                    </div>
                </div>
            </div>

            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ServiceSinglePage;